import type { SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { useApi } from '@gik/core/api/swr/useApi';
import type { InkindPageAPIModel } from '@gik/models/gik/InkindPage';
import type { WalletEntity } from '@gik/platform-management-api-js';

type InkindWallet = WalletEntity &
  Pick<InkindPageAPIModel, 'title'> & {
    isUserRecipient?: boolean; // GIK-9790 / GIK-10301
    isUserPageOwner?: boolean; // GIK-10301
    pageOwnerIsActive?: boolean; // GIK-10301
  };

export function useUserWallets(userId?: string, config?: SWRConfigInterface) {
  return useApi<InkindWallet[]>(userId ? `users/${userId}/wallets` : null, null, config);
}
